export const formatDateChip = (from, to) => {
  if (from && to) return from === to ? from : `${from} → ${to}`;
  if (from) return `Từ ${from}`;
  if (to) return `Đến ${to}`;
  return "";
};

export const resolveOptionLabel = (id, options, idKey = "id", labelKeys = ["name", "lineName", "label", "code"]) => {
  if (!id) return "";
  const found = (options || []).find((o) => String(o[idKey]) === String(id));
  if (!found) return String(id);
  for (const key of labelKeys) {
    if (found[key]) return found[key];
  }
  return String(id);
};

export const resolveMapLabel = (value, map) => {
  if (!value) return "";
  return map?.[value]?.label || value;
};

/**
 * @param {object} applied - applied filter state
 * @param {Array<{key: string, label: string, isActive?: (v, applied) => boolean, formatValue?: (v, applied) => string}>} fieldDefs
 */
export const buildChips = (applied, fieldDefs) => {
  const chips = [];
  (fieldDefs || []).forEach((def) => {
    const value = applied?.[def.key];
    const active = def.isActive
      ? def.isActive(value, applied)
      : value !== undefined && value !== null && value !== "";
    if (!active) return;
    const display = def.formatValue ? def.formatValue(value, applied) : String(value);
    if (!display) return;
    chips.push({ key: def.key, label: def.label, value: display });
  });
  return chips;
};

export const countActiveChips = (chips) => (chips || []).length;
